import React from 'react';
import { saudiRiyalSymbol, saudiRiyalSymbolDark } from '../../utils/affiliateCurrency';
import { useTheme } from '../../contexts/ThemeContext';

const SIZE_CLASS = {
  sm: 'h-4',
  md: 'h-6',
  lg: 'h-8'
};

/** Saudi Riyal symbol image for affiliate earnings cards */
const SaudiRiyalIcon = ({ className = '', size = 'md' }) => {
  const { isDark } = useTheme();

  return (
    <img
      src={isDark ? saudiRiyalSymbolDark : saudiRiyalSymbol}
      alt=""
      className={`${SIZE_CLASS[size] || SIZE_CLASS.md} w-auto object-contain affiliate-sar-symbol ${className}`}
      aria-hidden="true"
    />
  );
};

export default SaudiRiyalIcon;
